import { render, staticRenderFns } from "./PeriodDetail.vue?vue&type=template&id=7bf3763a"
import script from "../../../controllers/custom/academic_period/period-detail.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/academic_period/period-detail.js?vue&type=script&lang=js&external"
import style0 from "./PeriodDetail.vue?vue&type=style&index=0&id=7bf3763a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports